import PixelIcon from '@/components/ui/PixelIcon';
import React from 'react';

export interface NavigationItem {
  id: string;
  label: string;
  icon: React.ReactNode;
  path?: string;
  onClick?: () => void;
  variant: 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info';
  shortcut: string;
}

// Single source of truth for all navigation items
export const navigationConfig = {
  worlds: {
    id: 'worlds',
    label: 'Worlds',
    icon: <PixelIcon name="worlds" />,
    path: '/worlds',
    variant: 'primary' as const,
    shortcut: 'W',
  },
  levels: {
    id: 'levels',
    label: 'Levels',
    icon: <PixelIcon name="levels" />,
    path: '/levels',
    variant: 'secondary' as const,
    shortcut: 'L',
  },
  upgrades: {
    id: 'upgrades',
    label: 'Upgrades',
    icon: <PixelIcon name="upgrades" />,
    path: '/upgrades',
    variant: 'success' as const,
    shortcut: 'U',
  },
  shop: {
    id: 'shop',
    label: 'Shop',
    icon: <PixelIcon name="shop" />,
    path: '/shop',
    variant: 'warning' as const,
    shortcut: 'O',
  },
  settings: {
    id: 'settings',
    label: 'Settings',
    icon: <PixelIcon name="settings" />,
    variant: 'info' as const,
    shortcut: 'S',
  },
  profile: {
    id: 'profile',
    label: 'Profile',
    icon: <PixelIcon name="user" />,
    path: '/profile',
    variant: 'success' as const,
    shortcut: 'P',
  },
  home: {
    id: 'home',
    label: 'Home',
    icon: <PixelIcon name="home" />,
    path: '/',
    variant: 'primary' as const,
    shortcut: 'H',
  },
  play: {
    id: 'play',
    label: 'Play Game',
    icon: <PixelIcon name="play" />,
    path: '/game',
    variant: 'primary' as const,
    shortcut: 'Enter',
  },
  continue: {
    id: 'continue',
    label: 'Continue Game',
    icon: <PixelIcon name="continue" />,
    path: '/game',
    variant: 'primary' as const,
    shortcut: 'Enter',
  },
  restart: {
    id: 'restart',
    label: 'Restart',
    icon: <PixelIcon name="restart" />,
    variant: 'warning' as const,
    shortcut: 'R',
  },
  pause: {
    id: 'pause',
    label: 'Pause',
    icon: <PixelIcon name="pause" />,
    variant: 'secondary' as const,
    shortcut: 'P',
  },
};

// Helper to get navigation items for specific contexts
export function getMobileNavItems(): NavigationItem[] {
  return [
    navigationConfig.worlds,
    navigationConfig.shop,
    navigationConfig.upgrades,
    navigationConfig.settings,
    navigationConfig.profile,
  ];
}

export function getHomeScreenButtons() {
  return {
    play: navigationConfig.play,
    continue: navigationConfig.continue,
    levels: navigationConfig.levels,
    shop: navigationConfig.shop,
    settings: navigationConfig.settings,
  };
}

export function getGameScreenButtons() {
  return {
    home: navigationConfig.home,
    restart: navigationConfig.restart,
    pause: navigationConfig.pause,
    settings: navigationConfig.settings,
    shop: navigationConfig.shop,
  };
}
